import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import HelperHTTP from "src/_utils/http_module_handler";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import { remotePath } from "src/base/settings/Paths";
import { signInSuccess } from "src/base/store/authSlice";

const AuthWithProviders = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { trans } = useEBSSSLayout();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(3);

  const handleCloseNow = () => {
    window.close(); // Attempt to close the window instantly
  };

  const fetchUserData = async () => {
    const token = searchParams.get(params?.provider);
    if (token) {
      const { data } = await HelperHTTP.customRequest(remotePath.clientInstanceUrl(), remotePath.endPoints.USER_INFO)
        .authed({ tk: "Bearer " + searchParams.get(params?.provider) })
        .appendQuery({ token_jwt: searchParams.get(params?.provider) })
        .api()
        .get();

      if (data) {
        dispatch(signInSuccess(data));
        return;
      }

      toast(trans("website.error-occurred"), { type: "error" });
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.close();
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-dark text-center">
      <h1 className="mb-4">{trans("website.you-can-close-this-tab")}</h1>
      <p className="mb-4">
        {trans("website.will-be-automatically-closed-in")} <strong>{countdown}</strong> {trans("common.seconds")}.
      </p>
      <button className="btn btn-primary" onClick={handleCloseNow}>
        {trans("website.close-now")}
      </button>
    </div>
  );
};

export default AuthWithProviders;
